<section role="search" class="search">
  <div class="form">
    <kb-input on="background" [standalone]="true" [ariaLabel]="intl.searchInputLabel" [placeholder]="intl.searchInputLabel" type="search" [name]="name" [ngModel]="query" (ngModelChange)="onQueryChange($event)">
      <button slot="trailer" type="submit" kb-icon icon-uppercase icon-center [icon]="iconSearch" [attr.aria-label]="intl.searchSubmitLabel"></button>
    </kb-input>
    <button class="close-open-button" type="button" kb-icon icon-uppercase icon-center [attr.aria-label]="intl.closeSearchButtonLabel" [icon]="iconCloseSearch" action--hide></button>
  </div>
  <button class="close-open-button" type="button" kb-icon icon-uppercase icon-center [attr.aria-label]="intl.openSearchButtonLabel" [icon]="iconOpenSearch" action--show></button>
</section>
